import api from "@/composables/api";
import { useUser } from "@/stores";
import { ref } from "vue";

export default () => {
  const sortedTableData = ref([]);
  const copied = ref([]);
  const errored = ref([]);
  const deleting = ref(null);
  const clickedRows = ref([]);
  const showButtons = ref(true);

  const setTableData = (data) => {
    sortedTableData.value = data;
  };

  const getTableData = () => {
    return sortedTableData.value;
  };

  return {
    sortedTableData,
    setTableData,
    getTableData,
    copied,
    errored,
    deleting,
    clickedRows,
    showButtons,
  };
};
